import type { UserRole } from "@/app/userRole";
import { EmptyState } from "@/shared/ui/emptyState/public";

// 권한이 부족해 화면을 열 수 없을 때 본문 위치에 표시하는 안내다. 페이지 셸(GNB·헤더) 안에서
// 렌더되므로 사용자는 여기서 다른 메뉴로 이동할 수 있다. 그래서 페이지 전체를 리다이렉트하지 않는다.
export function RestrictAccess({ requiredRoles }: { requiredRoles?: readonly UserRole[] }) {
  return (
    <EmptyState size="lg" tone="error">
      {restrictionMessage(requiredRoles)}
    </EmptyState>
  );
}

// 등급은 admin·member 둘뿐이다. 그래서 등급 게이트가 막았다면 admin 전용 화면이다.
// 등급 게이트가 없는데 막혔다면 원인은 서버가 계산한 permission(예: research group)이다.
function restrictionMessage(requiredRoles: readonly UserRole[] | undefined): string {
  return requiredRoles?.includes("admin") === true
    ? "이 화면은 관리자만 볼 수 있습니다."
    : "이 화면을 볼 권한이 없습니다.";
}
